export const NEXT_PUBLIC_ABSMARTLY_URL = 'https://nerdwallet.absmartly.io/v1';
export const NEXT_PUBLIC_SUPERGRAPH_URL = 'https://www.nerdwallet.com/api/supergraph';
